import { useMutation, useQuery } from '@tanstack/react-query';
import { createConversation, getAiModels, getAssetPresignUrl, getListChat, getMessageInChat, ICreateConversation, IMessageRequest, IMessageRequestBE, IStopConversation, sendMessage, sendMessageInChat, stopConversation } from '../api/chat';


export const useChatStream = () => {
  const mutation = useMutation({
    mutationFn: async ({ message, onChunk }: { message: IMessageRequest, onChunk: (chunk: string) => void }) => {
      return await sendMessage(message, onChunk);
    }
  });

  const sendMessageStream = async (message: IMessageRequest, onChunk: (chunk: string) => void) => {
    mutation.mutate({ message, onChunk });
  };

  return {
    sendMessage: sendMessageStream,
    isLoading: mutation.isPending,
    error: mutation.error?.message || null,
  };
}; 

//get list chat
export const useGetListChat = (params: { limit: number, offset: number, search: string }) => {
  const query = useQuery({
    queryKey: ['listChat', params.offset, params.limit, params.search],
    queryFn: () => getListChat(params.offset, params.limit, params.search),
    placeholderData: (previousData) => previousData
  });

  return {
    isFetching: query.isFetching,
    data: query.data?.items,
    isLoading: query.isLoading,
    error: query.error?.message || null,
  };
};

//get message in chat
export const useGetMessageInChat = (conversationId: string | null, params: { offset: number, limit: number }) => {
  const isValidUUID = (id: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id);
  
  const query = useQuery({
    queryKey: ['messageInChat', conversationId],
    queryFn: () => getMessageInChat(conversationId, params),
    enabled: !!conversationId && (conversationId && isValidUUID(conversationId) ? false : true),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error?.message || null,
  };
};

//get ai models
export const useGetAiModels = () => {
  const query = useQuery({
    queryKey: ['aiModels'],
    queryFn: getAiModels,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error?.message || null,
  };
};

//send message in chat
export const useSendMessageInChat = () => {
  const mutation = useMutation({
    mutationFn: (payload: { conversationId: string, message: IMessageRequestBE }) => sendMessageInChat(payload.conversationId, payload.message),
  });

  return {
    sendMessage: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error?.message || null,
  };
};

//create conversation
export const useCreateConversation = () => {
  const mutation = useMutation({
    mutationFn: (payload: ICreateConversation) => createConversation(payload),
  });

  return {
    createConversation: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error?.message || null,
  };
};

//get asset presign url
export const useGetAssetPresignUrl = () => {
  const mutation = useMutation<{ presignUrl: string, url: string }, Error, { fileName: string, fileType: string, fileExt: string }>({
    mutationFn: (payload: { fileName: string, fileType: string, fileExt: string }) => getAssetPresignUrl(payload.fileName, payload.fileType, payload.fileExt),
  });

  return {
    getAssetPresignUrl: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error?.message || null,
  };
};

//stop conversation
export const useStopConversation = () => {
  const mutation = useMutation({
    mutationFn: (payload: IStopConversation) => stopConversation(payload),
 
  });

  return {
    stopConversation: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error?.message || null,
  };
};
    